<h1 mat-dialog-title>Delete Viewer Protocol</h1>
<button mat-dialog-close mat-icon-button test-id="close-dialog">
  <mat-icon>close</mat-icon>
</button>

<div class="fill" mat-dialog-content [class.hidden]="isLoading">
  <p class="description dialog-padding" [innerHTML]="warningHTML"></p>
  <div class="table-wrapper">
    <table mat-table [dataSource]="tasks$">
      <ng-container matColumnDef="label">
        <th *matHeaderCellDef mat-header-cell>Label</th>
        <td *matCellDef="let row" mat-cell test-id="row-label">
          <fw-ellipsis [text]="row.label || ''" />
        </td>
      </ng-container>

      <ng-container matColumnDef="container">
        <th *matHeaderCellDef mat-header-cell>{{ 'Container' | titlecase }}</th>
        <td *matCellDef="let row" mat-cell test-id="row-container">
          <span>{{ row.container }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th *matHeaderCellDef mat-header-cell>Assignee</th>
        <td *matCellDef="let row" mat-cell test-id="row-assignee">
          @if (row.user.firstname) {
            <app-avatar [enableAnimation]="true" [enablePopover]="false" [users]="row.user" />
            <span>{{ row.user.firstname }} {{ row.user.lastname }}</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th *matHeaderCellDef mat-header-cell>Date Due</th>
        <td *matCellDef="let row" mat-cell test-id="row-dueDate">
          <span>{{ row.due_date }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let row" mat-cell test-id="row-dueDate">
          <span>{{ row.status }}</span>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="tableColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: tableColumns" mat-row></tr>
    </table>
    <mat-paginator [length]="totalRows" [pageSize]="10" (page)="loadPage($event.pageIndex)" />
  </div>
</div>

@if (isLoading) {
  <fw-loading />
}

<div align="end" class="action-buttons" mat-dialog-actions>
  <button color="error" mat-dialog-close mat-stroked-button test-id="close-button" (click)="cancel()">Cancel</button>
  <button color="warn" mat-flat-button test-id="delete-continue-button" (click)="confirm()">
    Delete Protocol and Tasks
  </button>
</div>
